'use client';

import type { AnimationItem } from 'lottie-web';
import type { MutableRefObject } from 'react';
import { lazy, Suspense } from 'react';

const LottieComponent = lazy(() => import('./Lottie'));

interface LottieProps {
  src: string;
  loop?: boolean;
  autoplay?: boolean;
  controller?: MutableRefObject<AnimationItem | null>;
  className?: string;
  onLoadedImages?: () => void;
}

export const Lottie = (props: LottieProps) => (
  <Suspense fallback={null}>
    <LottieComponent {...props} />
  </Suspense>
);
